export const STATUS = {
  all: "all",
  active: "active",
  fail: "fail",
  giveUp: "giveUp",
  drop: "drop",
};

export const ASS_STATUS = {
  submitted: { message: "제출 완료", color: "primary" },
  accepted: { message: "패스", color: "success" },
  fail: { message: "Fail", color: "error" },
  error: { message: "링크 에러", color: "secondary" },
  outstanding: { message: "잘함", color: "warning" },
  resubmitted: { message: "재제출", color: "info" },
};
